import React from 'react'
import '../../iPhone13-responsive.css'
import HeroSection from '../../luxury/components/hero-section'
import PromiseSection from '../../luxury/components/promise-section'
import RoomGalleries from '../../luxury/components/room-galleries'
import NewArrivals from '../../luxury/components/new-arrivals'
import StyleCurator from '../../luxury/components/style-curator'
import ArtPrints from '../../luxury/components/art-prints'
import MonthlyMuse from '../../luxury/components/monthly-muse'
import MakersShowcase from '../../luxury/components/makers-showcase'
import DesignerPicks from '../../luxury/components/designer-picks'
import TestimonialWall from '../../luxury/components/testimonial-wall'
import MiniDocumentary from '../../luxury/components/mini-documentary'
import ExperienceSection from '../../luxury/components/experience-section'
import StyleJournal from '../../luxury/components/style-journal'

export default function Home() {
  return (
    <div className="relative overflow-x-hidden">
      <main className="mobile-smooth-scroll min-h-screen">
        <HeroSection />
        <PromiseSection />
        <RoomGalleries />
        <NewArrivals />
        <StyleCurator />
        <ArtPrints />
        <MonthlyMuse />
        <MakersShowcase />
        <DesignerPicks />
        <TestimonialWall />
        <MiniDocumentary />
        <ExperienceSection />
        <StyleJournal />
      </main>
    </div>
  )
}